// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"f32b50b6","242":"f32b50b6","286":"f32b50b6","337":"f32b50b6","427":"6d1de105"}[chunkId] + ".chunk.css";
};